const footerConfig = {
  institutionName: "Colegio de Abogados Córdoba",
  legalName: "Colegio de Abogados de Córdoba",
  phone: "0351 568-2901",
  address: "Av. Duarte Quirós 571, X5000 Córdoba",
  showCurrentYear: true,
  fixedYear: null,
};

export default footerConfig;
